// OVERBET FAV win% by field size — seed = full-year backtest (22,412 races / 5,113
// flagged). The Signal Effects learner refreshes these forward via
// GET /api/quickpick/overbet-stats; the seed keeps the tooltip accurate offline.
const SEED = {
  "<=5": [30.3, 45.7], "6-7": [24.3, 39.7], "8": [22.4, 35.0],
  "9-10": [21.1, 32.7], "11+": [17.2, 29.6],
};
let cache = SEED;
let started = false;

export function overbetFsBucket(fs) {
  return fs <= 5 ? "<=5" : fs <= 7 ? "6-7" : fs === 8 ? "8" : fs <= 10 ? "9-10" : "11+";
}

function ensureFetch() {
  if (started) return;
  started = true;
  const base = process.env.REACT_APP_BACKEND_URL;
  if (!base) return;
  fetch(`${base}/api/quickpick/overbet-stats`)
    .then((r) => r.json())
    .then((d) => {
      const by = d && d.stats && d.stats.by_fs;
      if (!by) return;
      const m = { ...SEED };
      Object.keys(by).forEach((k) => { m[k] = [by[k].overbet_win, by[k].normal_win]; });
      cache = m;
    })
    .catch(() => {});
}

export function overbetTip(fieldSize) {
  ensureFetch();
  const b = overbetFsBucket(Number(fieldSize) || 0);
  const [ob, norm] = cache[b] || cache["6-7"];
  return `Overbet — historically wins ~${Math.round(ob)}% in fields this size `
    + `vs ~${Math.round(norm)}% for a normal favorite.`;
}
